import type { INavigationControlIntegrationApi } from '../navigationControl/interfaces';
import type { DefaultOrientationProvider } from './DefaultOrientationProvider';
import { ViewPortManipulationApiBase } from './ViewPortManipulationApiBase';
import type * as THREE from 'three';

export class NavigationControlIntegrationApi
  extends ViewPortManipulationApiBase
  implements INavigationControlIntegrationApi
{
  private readonly _orientationProvider: DefaultOrientationProvider;

  public constructor(orientationProvider: DefaultOrientationProvider) {
    super();
    this._orientationProvider = orientationProvider;
  }

  // INavigationControlIntegrationApi

  public getCenterPoint(): THREE.Vector3 {
    return this._getViewPortController().getCommonCenterPoint();
  }

  public getCameraDirection(): THREE.Vector3 {
    return this._getCameraController().getCameraDirection();
  }

  public getCameraTop(): THREE.Vector3 {
    return this._getCameraController().getCameraTop();
  }

  public zoomCamera(factor: number): void {
    this._getCameraController().zoomCamera(factor);
  }

  public panCamera(vector: THREE.Vector3): void {
    this._getCameraController().panCamera(vector);
  }

  public rotateCamera(position: THREE.Vector3, direction: THREE.Vector3, angleRad: number): void {
    this._getCameraController().rotateCamera(position, direction, angleRad);
  }

  public resetCamera(): void {
    this._getViewPortController().resetView();
  }
}
